module.exports = __webpack_public_path__ + "static/media/format_numbered-list.e182dc06.svg";